import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import Logo from '../images/shop_logo.png';
import Back from '../images/back1.webp';
import '../styles/Login.css';
import '../styles/Landing.css';
import Loader from "./Loader";
import SuccessModal from './SuccessModal';
import {SHOP_ADDRESS, SHOP_PHONE } from '../Variables.js';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [signingIn, setSigningIn] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { logIn } = useUserAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const loadImage = (src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
      });
    };

    loadImage(Back).then(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSigningIn(true);
    try {
      await logIn(email, password);
      setSigningIn(false);
      navigate("/home");
    } catch (err) {
      setSigningIn(false);
      setError("Invalid email or password");
      setShowModal(true);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  if (loading) {
    return <Loader text={"Loading"}/>;
  }

  return (
    <>
      {signingIn && <Loader text={"Authenticating"}/>}     
      <div className="login-page-items login-page-items-landing login-page-items-pos column align-center" style={{backgroundImage: `url(${Back})`}}>
        <div className="landing-page-top">
          <div className="column align-center justify-center">
            <img src={Logo} className="landing-logo" alt="logo" />
            <p className="text-center"><span className="title size2">CASHFLOW</span><br /><span className="bold size3">Finance</span><br/><span className="size5 desktop-text1  italics">{SHOP_ADDRESS}</span><br/><span className="size5 desktop-text1 italics">{SHOP_PHONE}</span></p>            
          </div>
        </div>
        <div className="form-items">
          <form className="login-form-pos" onSubmit={handleSubmit}>
            <input
              type="email"
              id="login-email"
              className="input-field"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <div style={{ position: 'relative', display: 'inline' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                id="login-password"
                className="input-field"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span
                onClick={togglePasswordVisibility}
                style={{
                  position: 'absolute',
                  right: '16px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  userSelect: 'none'
                }}
              >
                <i className={showPassword ? `fa-solid fa-eye-slash font-teal` : `fa-solid fa-eye font-light-blue-cash`}></i>
              </span>
            </div>
              <button type="Submit" className="login-button login-button-pos">
                SIGN IN
              </button>
              <Link to="/forgot-password" className="row align-center justify-center text-center bold italics underline">Forgot Password? Click on this link to reset your password</Link>
          </form>
        </div>

        <div className="landing-page-bottom">
          <div>          
            <p className="paystack align-center justify-center">Produced by &nbsp;<a href="https://deroyale.com.ng" target="blank" className="logo size4 bold">DeRoy<span className="font-gold deroyale-at" style={{fontFamily: "'Cabin', Helvetica, Arial, sans-serif'"}}>@</span>l&#233;</a></p>
          </div>
        </div>
      </div>
      {showModal && 
        <SuccessModal
          icon="xmark"
          iconColor="red"
          message={error}
          onClose={() => {
            setError("");
            setShowModal(false);
          }}
        />
      }
    </>
  );
};

export default Login;
